const URLS = 'ivs.chinamobiledevice.com:11443/lingxi';
// const URLS = 'yd-out.jmkjsh.com'
export default {
    brand_name: '灵犀',
    employURL: '',
    privacyURL: '',
    baseYM: URLS,
    baseURL: `https://${URLS}`,
    wss: `wss://${URLS}/ws/tts`,
    baseURLFile: 'https://convert-test.shanghaijimu.com',
    baseURLWPS: 'https://wps.shanghaijimu.com',
};
